'use strict';
var parent = require('../../es/instance/fill');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/fill.js
// module id = 761
// module chunks = 13